module.exports = __webpack_public_path__ + "img/full5-min.c13373b6.png";